export default __webpack_public_path__ + "2962dacada191ba19b974cf8f2543f25.woff";